import { useTheme } from 'styled-components';

export const LikeIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      className={className}
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.30101 6.11719H0.471558C0.207243 6.11719 0 6.30102 0 6.53549V13.2278C0 13.4623 0.207243 13.6461 0.471558 13.6461H3.30101C3.56532 13.6461 3.77257 13.4623 3.77257 13.2278L3.77189 6.53549C3.77257 6.30102 3.56532 6.11719 3.30101 6.11719Z"
        fill={theme.white}
      />
      <path
        d="M16.0332 6.54861C16.0332 5.83077 15.5534 5.10469 14.6363 5.10469H10.4791C11.0727 4.0143 11.2477 2.48096 10.8347 1.35871C10.5317 0.533614 9.95165 0.0518751 9.20228 0.00300096L9.18992 0.0017315C8.70204 -0.0287336 8.2797 0.346369 8.23889 0.8465C8.13192 1.95975 7.65702 3.92794 6.97621 4.62677C6.40299 5.21513 5.91201 5.46202 5.09895 5.87012C4.98146 5.92915 4.85284 5.99389 4.7168 6.06307C4.71927 6.09353 4.72051 6.12336 4.72051 6.15446V13.1298C4.81882 13.164 4.91591 13.1983 5.01113 13.2319C6.35358 13.7067 7.51414 14.1167 9.28772 14.1167H12.6484C13.5654 14.1167 14.0453 13.39 14.0453 12.6728C14.0453 12.4595 14.0032 12.2463 13.9197 12.0508C14.2252 11.9943 14.4923 11.8439 14.6908 11.6129C14.9159 11.3507 15.0396 11.0023 15.0396 10.6316C15.0396 10.4196 14.9975 10.2057 14.9147 10.0109C15.6511 9.88015 16.0345 9.23149 16.0345 8.59045C16.0345 8.21852 15.9053 7.84405 15.6536 7.56988C15.904 7.29506 16.0332 6.92054 16.0332 6.54861Z"
        fill={theme.white}
      />
    </svg>
  );
};
